import React, { useEffect, useState } from "react";

import { Box } from "@catchoftheday/cg-components";
import { useEventBus } from "@catchoftheday/state";
import { css } from "@catchoftheday/theme";
import { getCookie } from "@catchoftheday/utilities";

import { TRIGGER_ADULT_MODAL_EVENT } from "./trigger";

type AdultBlurContainerProps = {
  adult?: boolean;
  children: React.ReactNode;
};

export const AdultBlurContainer = ({
  adult = false,
  children,
}: AdultBlurContainerProps) => {
  const [open, setOpen] = useState(adult);

  useEventBus<{ open: boolean }>(TRIGGER_ADULT_MODAL_EVENT, (event) => {
    if (event.payload) {
      const { open } = event.payload;
      setOpen(open);
    }
  });

  useEffect(() => {
    if (adult) {
      const hasAdultCookie = getCookie("over18", false);
      setOpen(!hasAdultCookie);
    }
  }, [adult]);

  return (
    <Box
      css={
        open
          ? css`
              filter: blur(20px);
            `
          : undefined
      }
    >
      {children}
    </Box>
  );
};
